import { FetchClient } from '../types'
import { ClientSessionResponse } from './types'

const BASE_PREFIX = `/api/truework-js/client/session`

export const clientSessionEndpoints = (fetchClient: FetchClient) => {
  return {
    async getClientSession() {
      return fetchClient<ClientSessionResponse>(BASE_PREFIX)
    },
    async gatherSessionConsent() {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/consent`, { method: 'POST' })
    },
    async configureSession(publishableKey: string) {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/configure`, {
        method: 'POST',
        body: JSON.stringify({ publishable_key: publishableKey }),
      })
    },
    async manuallyTriggerIES() {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/advance_to_ies`, { method: 'POST' })
    },
    async completeSession() {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/complete`, { method: 'POST' })
    },
  }
}
